import { render, staticRenderFns } from "./StatementError.vue?vue&type=template&id=0a085432&scoped=true"
import script from "./StatementError.vue?vue&type=script&lang=ts"
export * from "./StatementError.vue?vue&type=script&lang=ts"
import style0 from "./StatementError.vue?vue&type=style&index=0&id=0a085432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a085432",
  null
  
)

export default component.exports